import { render, staticRenderFns } from "./Infographic.vue?vue&type=template&id=db7f0ba4&scoped=true&"
import script from "./Infographic.vue?vue&type=script&lang=js&"
export * from "./Infographic.vue?vue&type=script&lang=js&"
import style0 from "./Infographic.vue?vue&type=style&index=0&id=db7f0ba4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7f0ba4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VDialog,VImg})
